import {AvatarRectangle, Button, Subtitle, Hr} from '@/components/atoms';
import {
  Wrapper,
  RightArea,
  TitleArea,
  TextMiddleArea,
  Label,
  LabelArea,
  BottomArea,
} from './CreditPromoListItem.styled';

interface IProps {
  imgPath: string;
  bottomLine?: boolean;
  emphasis?: string | null;
  title: string;
  desc1: string;
  desc2?: string;
  onClick: () => void;
  detailBtnNm: string;
  annualTextList: { title: string; annual: string }[];
}

const CreditPromoListItem = (props: IProps) => {
  const {
    title,
    desc1,
    desc2,
    bottomLine = false,
    emphasis = null,
    onClick,
    detailBtnNm,
    imgPath,
    annualTextList,
  } = props;

  return (
    <Wrapper onClick={onClick}>
      <AvatarRectangle src={imgPath} alt={title}/>
      <RightArea>
        <TitleArea>
          {desc1 &&
            <Subtitle level={6} color="gray-600">
              {desc1}
            </Subtitle>
          }

          {desc2 &&
              <Subtitle level={6} color="gray-600">
                {desc2}
              </Subtitle>
          }
          <Subtitle level={4} color="gray-800">
            {title}
          </Subtitle>
        </TitleArea>

        <TextMiddleArea emphasis={emphasis}>
          { annualTextList.length > 0 &&
            <LabelArea emphasis={emphasis}>
              <Label>
                <Subtitle level={8}>{annualTextList[0].title}</Subtitle>
                <Subtitle level={8} color="gray-800">
                  {annualTextList[0].annual}
                </Subtitle>
              </Label>
              <Label>
                <Subtitle level={8}>{annualTextList[1].title}</Subtitle>
                <Subtitle level={8} color="gray-800">
                  {annualTextList[1].annual}
                </Subtitle>
              </Label>
            </LabelArea>
          }
          <BottomArea emphasis={emphasis}>
            {emphasis && (
              <Subtitle level={5} color="primary-100">
                {emphasis}
              </Subtitle>
            )}
            <Button size="sm">{detailBtnNm}</Button>
          </BottomArea>
        </TextMiddleArea>
        {bottomLine && <Hr/>}
      </RightArea>
    </Wrapper>
  );
};

export default CreditPromoListItem;
